export const data3_2_1 = [{
    name: 'Overall Review Rating 总体评论分数',
    name_code: 'Overall_Review_Rating',
    score: '0',
    action_plan: ""
}, {
    name: 'Total Reviews 评论总数',
    name_code: 'Total_Reviews',
    score: '0',
    action_plan: ""
}, {
    name: 'Location 地点',
    name_code: 'Location',
    score: '0',
    action_plan: ""
}, {
    name: 'Rooms 客房',
    name_code: 'Rooms',
    score: '0',
    action_plan: ""
}, {
    name: 'Cleanliness 整洁度',
    name_code: 'Cleanliness',
    score: '0',
    action_plan: ""
}, {
    name: 'Service 服务',
    name_code: 'Service',
    score: '0',
    action_plan: ""
}, {
    name: 'Value 价值',
    name_code: 'Value',
    score: '0',
    action_plan: ""
}];

export const data1 = [{
    name: "",
    name_code: "",
    action_plan: ""
}, {
    name: "",
    name_code: "",
    action_plan: ""
}, {
    name: "",
    name_code: "",
    action_plan: ""
}]

export const data2 = [{
    name: "Tripadvisor.com",
    name_code: "Tripadvisor.com",
    monitor_index2: "Stars (Example 4.0 of 5) 旅游者评星",
    monitor_index1: "Ranked X of XXX Hotels 城市总排名",
    col11: "",
    col12: "",
    col21: "",
    col22: "",
    col31: "",
    col32: "",
    col41: "",
    col42: "",
    col51: "",
    col52: "",
}, {
    name: "Daodao.com 道道网",
    name_code: "Daodao.com",
    monitor_index2: "Stars (Example 4.0 of 5) 旅游者评分总分五分",
    monitor_index1: "Ranked #X of XXX Hotels 城市总排名",
    col11: "",
    col12: "",
    col21: "",
    col22: "",
    col31: "",
    col32: "",
    col41: "",
    col42: "",
    col51: "",
    col52: "",
}, {
    name: "Lvping.com 驴评网",
    name_code: "Lvping.com",
    monitor_index2: "Traveler's Rating 驴评用户评星数",
    monitor_index1: "Ranked #X of XXX Hotels 城市总排名",
    col11: "",
    col12: "",
    col21: "",
    col22: "",
    col31: "",
    col32: "",
    col41: "",
    col42: "",
    col51: "",
    col52: "",
}, {
    name: "Ctrip 携程 (Chinese Site/中文网站）",
    name_code: "Ctrip 携程 (Chinese Site/中文网站）",
    monitor_index2: "Guest Review Rating 客户评分数，总分五分",
    monitor_index1: "Gold/Silver Medal 金银牌",
    col11: "",
    col12: "",
    col21: "",
    col22: "",
    col31: "",
    col32: "",
    col41: "",
    col42: "",
    col51: "",
    col52: "",
}, {
    name: "Elong 艺龙 (Chinese Site/中文网站）",
    name_code: "Elong 艺龙 (Chinese Site/中文网站）",
    monitor_index2: "Traveler's Rating 艺龙用户评定金牌数",
    monitor_index1: "Crown/Diamond 皇冠钻石",
    col11: "",
    col12: "",
    col21: "",
    col22: "",
    col31: "",
    col32: "",
    col41: "",
    col42: "",
    col51: "",
    col52: "",
}, {
    name: "Booking.com",
    name_code: "Booking.com",
    monitor_index2: "Guest Review Rating 客户评分数，总分十分",
    monitor_index1: "Preferred Placement - 1st Page (Thumb Up) 第一页优先排名",
    col11: "",
    col12: "",
    col21: "",
    col22: "",
    col31: "",
    col32: "",
    col41: "",
    col42: "",
    col51: "",
    col52: "",
}, {
    name: "Agoda.com 雅高达",
    name_code: "Agoda.com 雅高达",
    monitor_index2: "Guest Review Rating 客户评分数，总分十分",
    monitor_index1: "Preferred Placement - 1st Page 第一页优先排名",
    col11: "",
    col12: "",
    col21: "",
    col22: "",
    col31: "",
    col32: "",
    col41: "",
    col42: "",
    col51: "",
    col52: "",
}, {
    name: "Expedia.com",
    name_code: "Expedia.com",
    monitor_index2: "Guest Review Rating 客户评分数，总分五分",
    monitor_index1: "Preferred Placement - 1st Page 第一页优先排名",
    col11: "",
    col12: "",
    col21: "",
    col22: "",
    col31: "",
    col32: "",
    col41: "",
    col42: "",
    col51: "",
    col52: "",
}]




// WEBPACK FOOTER //
// ./src/components/table/2-Analysis/2-7/data.js